export const iconFontAwesomePhotosImagesUnsplash = (
	<i className="fa-solid fa-unsplash"></i>
);
